import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { updateBillable } from "@/modules/work/billables/details/update/api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { attributed_to, ...rest } = values;
  const payload = {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };

  if ("attributed_to" in values) {
    payload.attributed_to = attributed_to?.id;
  }

  if (payload.milestones && Array.isArray(payload.milestones)) {
    payload.milestones = payload.milestones.map(m => {
      if (typeof m === 'object' && m !== null) {
        return m.id;
      }
      return m;
    });
  }

  return payload;
}

export function useUpdateBillable() {
  return useMutation({
    mutationFn: async ({ billableId, values }) => {
      const payload = buildPayload(values);
      return await updateBillable({ billableId, item: payload });
    },
    onSuccess: () => {
      invalidateAllQueries();
      toast.success("Billable updated successfully");
    },
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
  });
}
